module.exports = __webpack_public_path__ + "img/furnituregamma.5aeb9682.jpeg";